import { render, staticRenderFns } from "./UnilevelPage.vue?vue&type=template&id=749fc3a5&scoped=true&"
import script from "./UnilevelPage.vue?vue&type=script&lang=js&"
export * from "./UnilevelPage.vue?vue&type=script&lang=js&"
import style0 from "./UnilevelPage.vue?vue&type=style&index=0&id=749fc3a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749fc3a5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VTreeview})
